import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69d7e4ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert-message" }
const _hoisted_2 = ["innerHTML"]

import { toRefs } from 'vue'
  
export default /*#__PURE__*/_defineComponent({
  props: {
    message: null
  },
  setup(__props: any) {

const props = __props as {
    message: string
  }

  
  const { message } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      innerHTML: _ctx.$t(_unref(message))
    }, null, 8, _hoisted_2)
  ]))
}
}

})